import cx from "classnames";

/** Matches TaskManagementSection / JourneyFormSection tab trigger styling. */
export const getUsageSectionTabClassNames = (clientColour?: string | null) =>
  cx(
    "radix-state-inactive:border-0 radix-state-inactive:hover:border-b-2 radix-state-inactive:hover:!border-b-gray-200",
    "radix-state-active:border-b-2",
    clientColour
      ? `radix-state-active:border-b-[#${clientColour}]`
      : "radix-state-active:border-b-gray-400",
    clientColour ? `radix-state-active:text-[#${clientColour}]` : "",
  );
